import { $t } from '@/utils/languageAuto';
import { __decorate, __extends } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';

var ViewDetail = function (_super) {
  __extends(ViewDetail, _super);

  function ViewDetail() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.columns = [];
    return _this;
  }

  ViewDetail.prototype.created = function () {
    this.setColumns();
  };

  ViewDetail.prototype.setColumns = function () {
    this.columns = [{
      title: this.t('序号'),
      dataIndex: 'index',
      scopedSlots: {
        customRender: 'index'
      }
    }, {
      title: this.t('费用类型'),
      dataIndex: 'fee_type_text',
      filterEmpty: true
    }, {
      title: this.t('总金额'),
      align: 'right',
      scopedSlots: {
        customRender: 'amount'
      }
    }, {
      title: this.t('币种'),
      dataIndex: 'currency_code',
      filterEmpty: true
    }];
  };

  __decorate([Prop({
    type: Object,
    "default": function _default() {}
  })], ViewDetail.prototype, "detailsData", void 0);

  ViewDetail = __decorate([Component], ViewDetail);
  return ViewDetail;
}(Vue);

export default ViewDetail;